<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/logo/Boustead_Logo.png" alt="" height="22">
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo/Boustead_Logo.png" alt="" height="17">
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/images/logo/Boustead_Logo.png" alt="" height="22">
          </span>
          <span class="logo-lg">
            <img src="assets/images/BousteadLogoSmall.png" alt="" height="75" style="margin-top:16px !important;">
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

    </div>

    <div class="d-flex">

      <div class="dropdown d-inline-block d-lg-none ms-2" ngbDropdown>
        <!-- <button type="button" class="btn header-item noti-icon" id="page-header-search-dropdown" data-toggle="dropdown"
          aria-haspopup="true" ngbDropdownToggle aria-expanded="false">
          <i class="mdi mdi-magnify"></i>
        </button> -->
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu
          aria-labelledby="page-header-search-dropdown">

          <form class="p-3">
            <div class="m-0">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Search ..." aria-label="Recipient's username">
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit"><i class="mdi mdi-magnify"></i></button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="form-check form-switch form-switch-lg" style="align-self:center; padding-top: 7px;">
        <label>Light</label>
      </div>
      <div class="form-check form-switch form-switch-lg" style="align-self:center; padding-top: 7px;">
        <label>Dark</label>
        <input class="form-check-input" (click)="toggleDarkTheme()" type="checkbox" id="SwitchCheckSizelg"
          style="margin-left:-17px !important;">
      </div>

      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button type="button" class="btn header-item noti-icon" data-toggle="fullscreen" (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
          <!-- <img class="rounded-circle header-profile-user" [src]='userAvatar'> -->
          <span class="d-none d-xl-inline-block ms-1">{{username}}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
          <a class="dropdown-item" *ngIf="checkAccess('viewprofile')" (click)="userProfile()"><i
              class="bx bx-user font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.PROFILE' | translate}}</a>
          <div *ngIf="checkAccess('viewprofile')" class="dropdown-divider"></div>
          <a class="dropdown-item" href="javascript: void(0);" (click)="changePassword(changePassworModal)"><i
              class="mdi mdi-form-textbox-password font-size-16 align-middle me-1"></i>
            Change Password</a>
          <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"><i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            {{ 'HEADER.LOGIN.LOGOUT' | translate}}</a>
        </div>
      </div>
    </div>
  </div>
</header>
<ng-template #changePassworModal let-modal>
  <app-changepassword [token]="token"></app-changepassword>
</ng-template>